var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-loader-container"},[(!_vm.alldone)?_c('img',{staticClass:"loader-img",attrs:{"src":_vm.placeholder}}):_vm._e(),_c('img',{ref:"img",staticClass:"photo",style:({ transition: _vm.duration + 'ms', opacity: _vm.show ? 1 : 0 }),attrs:{"src":_vm.src},on:{"load":_vm.handleLoaded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }